import Cookies from 'js-cookie';
import { YAKIT_FORCE_SET_HOSTNAME_COOKIE_NAME } from '@adv-frontend/yastore-modules/lib';

// Опции, которые мы будем использовать по умолчанию для этой куки
const COOKIE_OPTIONS = { path: '/', sameSite: 'none', secure: true };

/*
 * Получает значение hostname из cookie.
 * Возвращает пустую строку, если куки нет.
 */
export const getHostnameCookie = (): string => Cookies.get(YAKIT_FORCE_SET_HOSTNAME_COOKIE_NAME) || '';

/*
 * Устанавливает или удаляет cookie для hostname.
 * @param value - Новое значение hostname. Если передана пустая строка или undefined, кука будет удалена.
 */
export const setHostnameCookie = (value: string | undefined) => {
    if (value) {
        // Устанавливаем куку с нужным значением
        Cookies.set(YAKIT_FORCE_SET_HOSTNAME_COOKIE_NAME, value, COOKIE_OPTIONS);
    } else {
        // Удаляем куку
        Cookies.remove(YAKIT_FORCE_SET_HOSTNAME_COOKIE_NAME, COOKIE_OPTIONS);
    }
};
